export default __webpack_public_path__ + "static/media/yearBuilt.d4695ef2.svg";